import React from 'react';
import styled from 'styled-components';
import {isMobileOnly} from 'react-device-detect';


const SearchBtnHeaderBlock = styled.div`
    position: absolute;
    width: ${isMobileOnly?'16px':'22px'};
    height: ${isMobileOnly?'16px':'22px'};
    right: ${isMobileOnly?'7px':'22px'};
    top: ${isMobileOnly?'7px':'8px'};
    background-image: url(${props => props.img || ''});
    background-position: center;
    background-repeat: no-repeat;
    ${isMobileOnly&&"background-size: cover;"}
`;

const SearchBtnHeader = ({ onClick }) => {
    return (
        <SearchBtnHeaderBlock img={"/assets/images/icon/header-search-icon.png"}
            onClick={onClick} />
    );
};

export default SearchBtnHeader;
